import { render, staticRenderFns } from "./ReturnQueryDetail.vue?vue&type=template&id=b973a4dc&scoped=true&"
import script from "./ReturnQueryDetail.vue?vue&type=script&lang=js&"
export * from "./ReturnQueryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReturnQueryDetail.vue?vue&type=style&index=0&id=b973a4dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b973a4dc",
  null
  
)

export default component.exports